import { ReceivablesSettings } from '../receivables/Access';
//FirmaEdit
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { toast } from "react-toastify";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Card,
  Tabs,
  Tab,
  Spinner,
} from "react-bootstrap";
import api from "../../axiosConfig";
import HelpModal from "../common/HelpModal";
import { useHelpHotkey } from "../../hooks/useHelpHotkey";
import TreeHelp from "../common/TreeHelp";
import DatePicker from "react-datepicker";
import AccountPickerModal from "../pickers/AccountPickerModal";
import SeriiConfig from "./SeriiConfig";
import MagazinOnline from "./MagazinOnline";

import "react-datepicker/dist/react-datepicker.css";

export default function FirmaEdit() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [gestiuni, setGestiuni] = useState([]);
  const { showHelp, setShowHelp } = useHelpHotkey();
  const [judete, setJudete] = useState([]);
  const [activeTab, setActiveTab] = useState("generale");
  const [optTaxaVama, setOptTaxaVama] = useState(null);
  const [optTvaVama, setOptTvaVama] = useState(null);
  const [optComisionVama, setOptComisionVama] = useState(null);

  const [showTaxaVamaPicker, setShowTaxaVamaPicker] = useState(false);
  const [showTvaVamaPicker, setShowTvaVamaPicker] = useState(false);
  const [showComisionVamaPicker, setShowComisionVamaPicker] = useState(false);

  const [form, setForm] = useState({
    bxid: 0,
    bxdenumire: "",
    bxcodfiscal: "",
    bxadresa: "",
    bxregcom: "",
    bxtara: "",
    bxtel: "",
    bxfax: "",
    bxemail: "",
    platitor_tva: false,
    tva_la_incasare: false,
    tva_inc_afiseaza_bifa: false,
    bxoras: "",
    bxjudet_id: 0,
    bxsector_id: 0,
    bxcodpostal: "",
    bxfirst_date: "",
    bxlast_date: "",
    versiune_baza: "",
    bxcod_judet_san: "",
    bxsector: "",
    bxcap_social: "",
    zecimale_cantitate: 0,
    zecimale_pret: 0,
    judet_str: "",
    m_token: "",
    m_token_refresh: "",
    m_token_dataexp: "",
    cu_conturi_900: false,
    cu_serii: false,
    cont_taxa_vama_id: 0,
    cont_tva_vama_id: 0,
    cont_comision_vama_id: 0,
    preturi_catalog_cu_tva: false,
    cont_banca1: "",
    nume_banca1: "",
    cont_banca2: "",
    nume_banca2: "",
    atribut: "",
    contor_visible: false,
    santier_visible: false,
    medic_visible: false,
    distribuire_pe_centre: false,
    debugging: false,
    ver_parts: 1,
    ver_cda: 1,
    app_variant: "STANDARD",
    is_2fa_enabled: false,
    data_instalarii: "",
    ok_go: false,
    tarif_skill1: 0.0,
    tarif_skill2: 0.0,
    service_print_part_codes: true,
    service_gestiune_sursa_id: "",
    service_gestiune_dest_id: "",
    productie_gestiune_sursa_id: "",
    productie_gestiune_dest_id: "",
  });

  useEffect(() => {
    api.get("/bxgestiune/?limit=100")
      .then(res => {
        const items = Array.isArray(res.data) ? res.data : (res.data?.items || []);
        setGestiuni(items);
      })
      .catch(e => console.error(e));

    api
      .get("/judet/?limit=100")
      .then((res) => {
        const items = Array.isArray(res.data)
          ? res.data
          : Array.isArray(res.data?.items)
            ? res.data.items
            : [];
        setJudete(items);
      })
      .catch((err) => console.error("Error loading judete:", err));
  }, []);

  const toBool = (val) => val === 1 || val === "1" || val === true || val === "true";

  useEffect(() => {
    let alive = true;
    api
      .get(`/firma/${id}`)
      .then((res) => {
        if (!alive) return;
        const d = res.data || {};
        setForm((f) => ({
          ...f,
          bxdenumire: d.bxdenumire ?? "",
          bxcodfiscal: d.bxcodfiscal ?? "",
          bxadresa: d.bxadresa ?? "",
          bxregcom: d.bxregcom ?? "",
          bxtara: d.bxtara ?? "",
          bxtel: d.bxtel ?? "",
          bxfax: d.bxfax ?? "",
          bxemail: d.bxemail ?? "",
          bxoras: d.bxoras ?? "",
          bxcodpostal: d.bxcodpostal ?? "",
          bxfirst_date: d.bxfirst_date ?? "",
          bxlast_date: d.bxlast_date ?? "",
          versiune_baza: d.versiune_baza ?? "",
          bxcod_judet_san: d.bxcod_judet_san ?? "",
          bxsector: d.bxsector ?? "",
          bxcap_social: d.bxcap_social ?? "",
          judet_str: d.judet_str ?? "",
          m_token: d.m_token ?? "",
          m_token_refresh: d.m_token_refresh ?? "",
          m_token_dataexp: d.m_token_dataexp ?? "",
          cont_banca1: d.cont_banca1 ?? "",
          nume_banca1: d.nume_banca1 ?? "",
          cont_banca2: d.cont_banca2 ?? "",
          nume_banca2: d.nume_banca2 ?? "",
          atribut: d.atribut ?? "",
          contor_visible:
            d.contor_visible === "1" ||
            d.contor_visible === "true" ||
            d.contor_visible === "yes",
          bxid: d.bxid ?? 0,
          platitor_tva: toBool(d.platitor_tva),
          tva_la_incasare: toBool(d.tva_la_incasare),
          tva_inc_afiseaza_bifa: toBool(d.tva_inc_afiseaza_bifa),
          bxjudet_id: d.bxjudet_id ?? 0,
          bxsector_id: d.bxsector_id ?? 0,
          zecimale_cantitate: d.zecimale_cantitate ?? 0,
          zecimale_pret: d.zecimale_pret ?? 0,
          cu_conturi_900: toBool(d.cu_conturi_900),
          cu_serii: toBool(d.cu_serii),
          cont_taxa_vama_id: d.cont_taxa_vama_id ?? 0,
          cont_tva_vama_id: d.cont_tva_vama_id ?? 0,
          cont_comision_vama_id: d.cont_comision_vama_id ?? 0,
          preturi_catalog_cu_tva: toBool(d.preturi_catalog_cu_tva),
          santier_visible: toBool(d.santier_visible),
          medic_visible: toBool(d.medic_visible),
          distribuire_pe_centre: toBool(d.distribuire_pe_centre),
          debugging: toBool(d.debugging),
          ver_parts: d.ver_parts ?? 1,
          ver_cda: d.ver_cda ?? 1,
          app_variant: d.app_variant ?? "STANDARD",
          is_2fa_enabled: toBool(d.is_2fa_enabled),
          data_instalarii: d.data_instalarii ?? "",
          ok_go: toBool(d.ok_go),
          tarif_skill1: d.tarif_skill1 ?? 0.0,
          tarif_skill2: d.tarif_skill2 ?? 0.0,
          service_print_part_codes: d.service_print_part_codes !== false,
          service_gestiune_sursa_id: d.service_gestiune_sursa_id || "",
          service_gestiune_dest_id: d.service_gestiune_dest_id || "",
          productie_gestiune_sursa_id: d.productie_gestiune_sursa_id || "",
          productie_gestiune_dest_id: d.productie_gestiune_dest_id || "",
        }));

        const loadAccountObj = async (accId, setter) => {
          if (!accId || accId === 0) {
            setter(null);
            return;
          }
          try {
            const accRes = await api.get(`/accounts/${accId}`);
            if (alive) {
              setter(accRes.data);
            }
          } catch (e) {
            console.error(`Failed to load account with id ${accId}:`, e);
            if (alive) {
              setter({ id: accId, simbol: "", denumire: `Cont #${accId}` });
            }
          }
        };

        loadAccountObj(d.cont_taxa_vama_id, setOptTaxaVama);
        loadAccountObj(d.cont_tva_vama_id, setOptTvaVama);
        loadAccountObj(d.cont_comision_vama_id, setOptComisionVama);

        setLoading(false);
      })
      .catch((err) => {
        alert(
          "Eroare la încărcare: " + (err.response?.data?.detail || err.message),
        );
        setLoading(false);
      });
    return () => {
      alive = false;
    };
  }, [id]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox") {
      setForm((f) => ({ ...f, [name]: checked }));
    } else if (type === "number") {
      setForm((f) => ({ ...f, [name]: value === "" ? "" : Number(value) }));
    } else if (name.endsWith("_id")) {
      setForm((f) => ({ ...f, [name]: value === "" ? 0 : Number(value) }));
    } else {
      setForm((f) => ({ ...f, [name]: value }));
    }
  };

  const handleDateChange = (fieldName, date) => {
    let str = "";
    if (date) {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, "0");
      const d = String(date.getDate()).padStart(2, "0");
      str = `${y}-${m}-${d}`;
    }
    setForm((f) => ({ ...f, [fieldName]: str }));
  };

  const handleAppVariantChange = (variant) => {
    if (variant === "LITE") {
      setForm((f) => ({
        ...f,
        app_variant: variant,
        santier_visible: false,
        contor_visible: false,
        ver_parts: 1,
        ver_cda: 1,
      }));
    } else {
      const isSimple =
        variant === "STANDARD" ||
        variant === "CONTOR" ||
        variant === "SERVICE_AUTO" || variant === "SANTIER";
      setForm((f) => ({
        ...f,
        app_variant: variant,
        ver_parts: 2,
        ver_cda: isSimple ? 1 : 2,
        santier_visible: variant === "SANTIER",
        contor_visible: variant === "CONTOR",
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setSubmitting(true);
      const payload = { ...form };

      payload.bxid = Number(form.bxid) || 0;
      payload.platitor_tva = form.platitor_tva ? 1 : 0;
      payload.tva_la_incasare = form.tva_la_incasare ? 1 : 0;
      payload.tva_inc_afiseaza_bifa = form.tva_inc_afiseaza_bifa ? 1 : 0;
      payload.bxjudet_id = Number(form.bxjudet_id) || 0;
      payload.bxsector_id = Number(form.bxsector_id) || 0;
      payload.zecimale_cantitate = Number(form.zecimale_cantitate) || 0;
      payload.zecimale_pret = Number(form.zecimale_pret) || 0;
      payload.cu_conturi_900 = form.cu_conturi_900 ? 1 : 0;
      payload.cu_serii = form.cu_serii ? 1 : 0;
      payload.cont_taxa_vama_id = Number(form.cont_taxa_vama_id) || 0;
      payload.cont_tva_vama_id = Number(form.cont_tva_vama_id) || 0;
      payload.cont_comision_vama_id = Number(form.cont_comision_vama_id) || 0;
      payload.preturi_catalog_cu_tva = form.preturi_catalog_cu_tva ? 1 : 0;
      payload.santier_visible = form.santier_visible ? 1 : 0;
      payload.medic_visible = form.medic_visible ? 1 : 0;
      payload.distribuire_pe_centre = Boolean(form.distribuire_pe_centre);
      payload.debugging = Boolean(form.debugging);
      payload.ver_parts = Number(form.ver_parts) || 1;
      payload.ver_cda = Number(form.ver_cda) || 1;
      payload.app_variant = form.app_variant || "STANDARD";
      payload.is_2fa_enabled = Boolean(form.is_2fa_enabled);
      payload.contor_visible = form.contor_visible ? "1" : "0";
      payload.bxfirst_date = form.bxfirst_date || null;
      payload.bxlast_date = form.bxlast_date || null;
      payload.m_token_dataexp = form.m_token_dataexp || null;
      payload.data_instalarii = form.data_instalarii || null;
      payload.ok_go = Boolean(form.ok_go);
      payload.tarif_skill1 = Number(form.tarif_skill1) || 0.0;
      payload.tarif_skill2 = Number(form.tarif_skill2) || 0.0;
      if(form.service_gestiune_sursa_id) payload.service_gestiune_sursa_id = Number(form.service_gestiune_sursa_id);
      if(form.service_gestiune_dest_id) payload.service_gestiune_dest_id = Number(form.service_gestiune_dest_id);
      if(form.productie_gestiune_sursa_id) payload.productie_gestiune_sursa_id = Number(form.productie_gestiune_sursa_id);
      if(form.productie_gestiune_dest_id) payload.productie_gestiune_dest_id = Number(form.productie_gestiune_dest_id);

      localStorage.setItem("firma_debugging", form.debugging ? "1" : "0");
      const res = await api.put(`/firma/${id}`, payload);
      if (res.data) {
        const d = res.data;
        setForm((f) => ({
          ...f,
          platitor_tva: toBool(d.platitor_tva),
          tva_la_incasare: toBool(d.tva_la_incasare),
          tva_inc_afiseaza_bifa: toBool(d.tva_inc_afiseaza_bifa),
          cu_conturi_900: toBool(d.cu_conturi_900),
          cu_serii: toBool(d.cu_serii),
          preturi_catalog_cu_tva: toBool(d.preturi_catalog_cu_tva),
          santier_visible: toBool(d.santier_visible),
          medic_visible: toBool(d.medic_visible),
          distribuire_pe_centre: toBool(d.distribuire_pe_centre),
          debugging: toBool(d.debugging),
          is_2fa_enabled: toBool(d.is_2fa_enabled),
          ok_go: toBool(d.ok_go),
        }));
      }
      try {
        toast.success("Datele firmei au fost salvate cu succes!");
      } catch (e) {}

    } catch (err) {
      alert(
        "Eroare la actualizare: " + (err.response?.data?.detail || err.message),
      );
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) {
    return (
      <Container className="mt-5 text-center">
        <Spinner animation="border" variant="primary" />
        <p className="mt-2 text-muted fw-semibold">Se încarcă datele firmei...</p>
      </Container>
    );
  }

  return (
    <Container className="mt-4 pb-5">
      <ReceivablesSettings />
      <Card className="shadow-sm border-0">
        <Card.Header className="bg-primary text-white d-flex justify-content-between align-items-center py-3">
          <h4 className="mb-0">
            Editare Firmă – {form.bxdenumire || `#${id}`}
          </h4>
          <Button
            variant="light"
            size="sm"
            onClick={() => setShowHelp(true)}
            title="Ajutor (F1)"
          >
            Manual Ajutor (F1)
          </Button>
        </Card.Header>
        <Card.Body className="p-4">
          <Form noValidate onSubmit={handleSubmit}>
            <Tabs
              id="firma-edit-tabs"
              activeKey={activeTab}
              onSelect={(k) => setActiveTab(k)}
              className="mb-4"
            >
              <Tab eventKey="generale" title="1. Date Generale">
                <Row className="g-3">
                  <Col md={2}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">
                        Cod / ID Firmă
                      </Form.Label>
                      <Form.Control
                        type="number"
                        name="bxid"
                        value={form.bxid ?? 0}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>

                  <Col md={7}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">
                        Denumire Firmă
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="bxdenumire"
                        value={form.bxdenumire ?? ""}
                        onChange={handleChange}
                        required
                        placeholder="Numele oficial al societății"
                      />
                    </Form.Group>
                  </Col>

                  <Col md={3}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">
                        Capital Social
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="bxcap_social"
                        value={form.bxcap_social ?? ""}
                        onChange={handleChange}
                        placeholder="ex: 200 RON"
                      />
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">
                        Cod Fiscal (CUI / CIF)
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="bxcodfiscal"
                        value={form.bxcodfiscal ?? ""}
                        onChange={handleChange}
                        required
                        placeholder="ex: 12345678"
                      />
                    </Form.Group>
                  </Col>

                  <Col md={2}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">
                        Atribut Fiscal
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="atribut"
                        value={form.atribut ?? ""}
                        onChange={handleChange}
                        placeholder="ex: RO"
                      />
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">
                        Registrul Comerțului
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="bxregcom"
                        value={form.bxregcom ?? ""}
                        onChange={handleChange}
                        placeholder="ex: J40/1234/2020"
                      />
                    </Form.Group>
                  </Col>

                  <Col md={12} className="mt-4">
                    <Card className="bg-light border-0 p-3">
                      <Row>
                        <Col md={4}>
                          <Form.Group>
                            <Form.Check
                              type="checkbox"
                              id="platitor_tva"
                              name="platitor_tva"
                              label="Plătitor de TVA"
                              checked={!!form.platitor_tva}
                              onChange={handleChange}
                              className="fw-semibold text-dark"
                            />
                            <Form.Text className="text-muted">
                              Bifați dacă firma este înregistrată în scopuri de
                              TVA.
                            </Form.Text>
                          </Form.Group>
                        </Col>

                        <Col md={4}>
                          <Form.Group>
                            <Form.Check
                              type="checkbox"
                              id="tva_la_incasare"
                              name="tva_la_incasare"
                              label="TVA la încasare"
                              checked={!!form.tva_la_incasare}
                              onChange={(e) => {
                                const checked = e.target.checked;
                                setForm((f) => ({
                                  ...f,
                                  tva_la_incasare: checked,
                                  tva_inc_afiseaza_bifa: checked
                                    ? f.tva_inc_afiseaza_bifa
                                    : false,
                                }));
                              }}
                              className="fw-semibold text-dark"
                            />
                            <Form.Text className="text-muted">
                              Aplică regimul de TVA la încasare.
                            </Form.Text>
                            <Form.Check
                              type="checkbox"
                              id="tva_inc_afiseaza_bifa"
                              name="tva_inc_afiseaza_bifa"
                              label="Afișează bifa TVA la încasare în ieșiri"
                              checked={!!form.tva_inc_afiseaza_bifa}
                              onChange={handleChange}
                              disabled={!form.tva_la_incasare}
                              className="fw-semibold text-dark mt-2"
                            />
                            <Form.Text className="text-muted d-block">
                              Permite modificarea bifei pe facturile de ieșire
                              (de ex. grup de firme).
                            </Form.Text>
                          </Form.Group>
                        </Col>

                        <Col md={4}>
                          <Form.Group>
                            <Form.Check
                              type="checkbox"
                              id="preturi_catalog_cu_tva"
                              name="preturi_catalog_cu_tva"
                              label="Prețuri catalog cu TVA inclus"
                              checked={!!form.preturi_catalog_cu_tva}
                              onChange={handleChange}
                              className="fw-semibold text-dark"
                            />
                            <Form.Text className="text-muted">
                              Prețurile din catalog conțin implicit taxa pe
                              valoarea adăugată.
                            </Form.Text>
                          </Form.Group>
                        </Col>
                      </Row>
                    </Card>
                  </Col>
                </Row>
              </Tab>

              <Tab eventKey="adresa" title="2. Adresă și Contact">
                <Row className="g-3">
                  <Col md={12}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">
                        Adresă Sediu Social
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="bxadresa"
                        value={form.bxadresa ?? ""}
                        onChange={handleChange}
                        placeholder="Strada, Număr, Bloc, Apartament etc."
                      />
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">
                        Oraș / Localitate
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="bxoras"
                        value={form.bxoras ?? ""}
                        onChange={handleChange}
                        placeholder="ex: Bucuresti, Timisoara"
                      />
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">Județ</Form.Label>
                      <Form.Select
                        name="bxjudet_id"
                        value={form.bxjudet_id ?? 0}
                        onChange={handleChange}
                      >
                        <option value={0}>-- Selectați Județul --</option>
                        {judete.map((j) => (
                          <option key={j.id} value={j.id}>
                            {j.denumire} ({j.cod})
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>

                  <Col md={2}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">Sector ID</Form.Label>
                      <Form.Control
                        type="number"
                        name="bxsector_id"
                        value={form.bxsector_id ?? 0}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>

                  <Col md={2}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">
                        Cod Poștal
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="bxcodpostal"
                        value={form.bxcodpostal ?? ""}
                        onChange={handleChange}
                        placeholder="ex: 010203"
                      />
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">
                        Denumire Sector / Zonă
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="bxsector"
                        value={form.bxsector ?? ""}
                        onChange={handleChange}
                        placeholder="ex: Sector 1"
                      />
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">Țară</Form.Label>
                      <Form.Control
                        type="text"
                        name="bxtara"
                        value={form.bxtara ?? ""}
                        onChange={handleChange}
                        placeholder="ex: Romania"
                      />
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">
                        Cod județ CAS — utilizat la declarațiile de salarii
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="bxcod_judet_san"
                        value={form.bxcod_judet_san ?? ""}
                        onChange={handleChange}
                        placeholder="ex: B, CJ, TM"
                      />
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">Telefon</Form.Label>
                      <Form.Control
                        type="text"
                        name="bxtel"
                        value={form.bxtel ?? ""}
                        onChange={handleChange}
                        placeholder="ex: 0722000000"
                      />
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">Fax</Form.Label>
                      <Form.Control
                        type="text"
                        name="bxfax"
                        value={form.bxfax ?? ""}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">Email</Form.Label>
                      <Form.Control
                        type="email"
                        name="bxemail"
                        value={form.bxemail ?? ""}
                        onChange={handleChange}
                        placeholder="ex: contact@firma.ro"
                      />
                    </Form.Group>
                  </Col>

                  <Col md={12}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">
                        Județ (Denumire Textuală)
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="judet_str"
                        value={form.judet_str ?? ""}
                        onChange={handleChange}
                        placeholder="ex: Bucuresti"
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Tab>

              <Tab eventKey="financiare" title="3. Date Financiare">
                <Row className="g-3">
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">
                        Cont IBAN Bancă 1
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="cont_banca1"
                        value={form.cont_banca1 ?? ""}
                        onChange={handleChange}
                        placeholder="RO00AAAA0000000000000000"
                      />
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">
                        Denumire Bancă 1
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="nume_banca1"
                        value={form.nume_banca1 ?? ""}
                        onChange={handleChange}
                        placeholder="ex: BCR, BRD"
                      />
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">
                        Cont IBAN Bancă 2
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="cont_banca2"
                        value={form.cont_banca2 ?? ""}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">
                        Denumire Bancă 2
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="nume_banca2"
                        value={form.nume_banca2 ?? ""}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>

                  {/* <Col md={3}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">Zecimale Cantitate</Form.Label>
                      <Form.Control
                        type="number"
                        name="zecimale_cantitate"
                        value={form.zecimale_cantitate ?? 0}
                        onChange={handleChange}
                        min={0}
                        max={6}
                      />
                    </Form.Group>
                  </Col>

                  <Col md={3}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">Zecimale Preț</Form.Label>
                      <Form.Control
                        type="number"
                        name="zecimale_pret"
                        value={form.zecimale_pret ?? 0}
                        onChange={handleChange}
                        min={0}
                        max={6}
                      />
                    </Form.Group>
                  </Col>

                  <Col md={6} className="d-flex align-items-center">
                    <Form.Group className="mb-0 mt-3">
                      <Form.Check
                        type="checkbox"
                        id="cu_conturi_900"
                        name="cu_conturi_900"
                        label="Utilizează conturi din clasa 9 (Contabilitate de gestiune)"
                        checked={!!form.cu_conturi_900}
                        onChange={handleChange}
                        className="fw-semibold"
                      />
                      
                    </Form.Group>
                  </Col> */}

                  <Col md={6} className="d-flex align-items-center">
                    <Form.Group className="mb-0 mt-3">
                      <Form.Check
                        type="checkbox"
                        id="cu_serii"
                        name="cu_serii"
                        label="Cu serii pe produse"
                        checked={!!form.cu_serii}
                        onChange={handleChange}
                        className="fw-semibold"
                      />
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">
                        Cont Taxă Vamă
                      </Form.Label>
                      <div
                        className="form-control d-flex align-items-center justify-content-between"
                        style={{ cursor: "pointer" }}
                        role="button"
                        tabIndex={0}
                        onClick={() => setShowTaxaVamaPicker(true)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            setShowTaxaVamaPicker(true);
                          }
                        }}
                      >
                        <span className={optTaxaVama ? "" : "text-muted"}>
                          {optTaxaVama
                            ? `${optTaxaVama.simbol ?? optTaxaVama.code ?? optTaxaVama.cod ?? ""} • ${
                                optTaxaVama.denumire ?? optTaxaVama.name ?? ""
                              }`
                            : "Alege cont…"}
                        </span>
                        {optTaxaVama ? (
                          <span
                            title="Șterge selecția"
                            style={{ padding: "0 6px", cursor: "pointer" }}
                            onClick={(e) => {
                              e.stopPropagation();
                              setOptTaxaVama(null);
                              setForm((f) => ({ ...f, cont_taxa_vama_id: 0 }));
                            }}
                          >
                            ✕
                          </span>
                        ) : (
                          <span
                            className="text-muted"
                            style={{ fontSize: "11px" }}
                          >
                            ▼
                          </span>
                        )}
                      </div>
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">
                        Cont TVA Vamă
                      </Form.Label>
                      <div
                        className="form-control d-flex align-items-center justify-content-between"
                        style={{ cursor: "pointer" }}
                        role="button"
                        tabIndex={0}
                        onClick={() => setShowTvaVamaPicker(true)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            setShowTvaVamaPicker(true);
                          }
                        }}
                      >
                        <span className={optTvaVama ? "" : "text-muted"}>
                          {optTvaVama
                            ? `${optTvaVama.simbol ?? optTvaVama.code ?? optTvaVama.cod ?? ""} • ${
                                optTvaVama.denumire ?? optTvaVama.name ?? ""
                              }`
                            : "Alege cont…"}
                        </span>
                        {optTvaVama ? (
                          <span
                            title="Șterge selecția"
                            style={{ padding: "0 6px", cursor: "pointer" }}
                            onClick={(e) => {
                              e.stopPropagation();
                              setOptTvaVama(null);
                              setForm((f) => ({ ...f, cont_tva_vama_id: 0 }));
                            }}
                          >
                            ✕
                          </span>
                        ) : (
                          <span
                            className="text-muted"
                            style={{ fontSize: "11px" }}
                          >
                            ▼
                          </span>
                        )}
                      </div>
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">
                        Cont Comision Vamă
                      </Form.Label>
                      <div
                        className="form-control d-flex align-items-center justify-content-between"
                        style={{ cursor: "pointer" }}
                        role="button"
                        tabIndex={0}
                        onClick={() => setShowComisionVamaPicker(true)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            setShowComisionVamaPicker(true);
                          }
                        }}
                      >
                        <span className={optComisionVama ? "" : "text-muted"}>
                          {optComisionVama
                            ? `${optComisionVama.simbol ?? optComisionVama.code ?? optComisionVama.cod ?? ""} • ${
                                optComisionVama.denumire ??
                                optComisionVama.name ??
                                ""
                              }`
                            : "Alege cont…"}
                        </span>
                        {optComisionVama ? (
                          <span
                            title="Șterge selecția"
                            style={{ padding: "0 6px", cursor: "pointer" }}
                            onClick={(e) => {
                              e.stopPropagation();
                              setOptComisionVama(null);
                              setForm((f) => ({
                                ...f,
                                cont_comision_vama_id: 0,
                              }));
                            }}
                          >
                            ✕
                          </span>
                        ) : (
                          <span
                            className="text-muted"
                            style={{ fontSize: "11px" }}
                          >
                            ▼
                          </span>
                        )}
                      </div>
                    </Form.Group>
                  </Col>
                </Row>
              </Tab>

              <Tab eventKey="anaf" title="4. e-Factura ANAF">
                <Row className="g-3">
                  <Col md={12}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">
                        Token ANAF (M Token)
                      </Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        name="m_token"
                        value={form.m_token ?? ""}
                        onChange={handleChange}
                        placeholder="Token-ul pentru autorizare in e-Factura"
                      />
                    </Form.Group>
                  </Col>

                  <Col md={12}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">
                        Refresh Token ANAF
                      </Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={2}
                        name="m_token_refresh"
                        value={form.m_token_refresh ?? ""}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">
                        Dată Expirare Token ANAF
                      </Form.Label>
                      <DatePicker
                        selected={
                          form.m_token_dataexp
                            ? new Date(form.m_token_dataexp)
                            : null
                        }
                        onChange={(date) =>
                          handleDateChange("m_token_dataexp", date)
                        }
                        dateFormat="dd.MM.yyyy"
                        className="form-control"
                        placeholderText="Selectați data"
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Tab>

              <Tab eventKey="admin" title="5. Administrare și Module">
                {user?.is_superuser && user?.user_name === "superadmin" && (
                  <Card className="shadow-sm border-danger mb-4">
                    <Card.Header className="bg-danger text-white fw-bold">
                      Control Acces Firmă (Doar Superadmin)
                    </Card.Header>
                    <Card.Body>
                      <Row className="g-3 align-items-center">
                        <Col md={4}>
                          <Form.Check
                            type="switch"
                            id="ok_go_switch"
                            label="Permite accesul permanent (ok_go)"
                            name="ok_go"
                            checked={form.ok_go}
                            onChange={handleChange}
                            className="fw-bold text-danger fs-5"
                          />
                          <Form.Text className="text-muted">
                            Dacă e debifat, clienții vor fi blocați după 30 de zile de la data instalării.
                          </Form.Text>
                        </Col>
                        <Col md={4}>
                          <Form.Group>
                            <Form.Label className="fw-semibold">Data Instalării (Start Trial)</Form.Label>
                            <DatePicker
                              selected={form.data_instalarii ? new Date(form.data_instalarii) : null}
                              onChange={(date) => handleDateChange("data_instalarii", date)}
                              dateFormat="dd.MM.yyyy"
                              className="form-control"
                              placeholderText="Selectați data"
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                )}
                <Row className="g-3">
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">
                        Prima zi (început exercițiu)
                      </Form.Label>
                      <DatePicker
                        selected={
                          form.bxfirst_date ? new Date(form.bxfirst_date) : null
                        }
                        onChange={(date) =>
                          handleDateChange("bxfirst_date", date)
                        }
                        filterDate={(date) => date.getDate() === 1}
                        dateFormat="dd.MM.yyyy"
                        className="form-control"
                        placeholderText="Selectați data"
                      />
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">
                        Ultima zi (sfârșit exercițiu)
                      </Form.Label>
                      <DatePicker
                        selected={
                          form.bxlast_date ? new Date(form.bxlast_date) : null
                        }
                        onChange={(date) =>
                          handleDateChange("bxlast_date", date)
                        }
                        dateFormat="dd.MM.yyyy"
                        className="form-control"
                        placeholderText="Selectați data"
                      />
                    </Form.Group>
                  </Col>

                  <Col md={12} className="mt-4">
                    <Card className="bg-light border-0 p-3">
                      <h6 className="fw-bold mb-3">
                        Module active și Depanare
                      </h6>
                      <Row className="g-3">
                        <Col md={6}>
                          <Form.Group>
                            <Form.Check
                              type="checkbox"
                              id="distribuire_pe_centre"
                              name="distribuire_pe_centre"
                              label="Distribuire pe centre de cost (validare la scrierea notei contabile)"
                              checked={!!form.distribuire_pe_centre}
                              onChange={handleChange}
                              className="fw-semibold"
                            />
                          </Form.Group>
                        </Col>

                        <Col md={6} style={{ display: "none" }}>
                          <Form.Group>
                            <Form.Check
                              type="checkbox"
                              id="medic_visible"
                              name="medic_visible"
                              disabled={user?.user_name !== "superadmin" || !user?.is_superuser}
                              label="Activează modul Cabinet Medical"
                              checked={!!form.medic_visible}
                              onChange={handleChange}
                              className="fw-semibold"
                            />
                          </Form.Group>
                        </Col>

                        <Col md={6}>
                          <Form.Group>
                            <Form.Check
                              type="checkbox"
                              id="debugging"
                              name="debugging"
                              label="Mod Depanare (Debugging)"
                              checked={!!form.debugging}
                              onChange={handleChange}
                              className="fw-semibold text-dark"
                            />
                            <Form.Text className="text-muted">
                              Activează logurile detaliate de depanare în
                              consolă pentru diagnosticare.
                            </Form.Text>
                          </Form.Group>
                        </Col>

                        <Col md={6}>
                          <Form.Group>
                            <Form.Label className="fw-semibold">
                              Dată Instalare (Trial)
                            </Form.Label>
                            <div>
                              <DatePicker
                                selected={
                                  form.data_instalarii
                                    ? new Date(form.data_instalarii)
                                    : null
                                }
                                onChange={(date) =>
                                  handleDateChange("data_instalarii", date)
                                }
                                dateFormat="dd.MM.yyyy"
                                className="form-control w-100"
                                placeholderText="Dată instalare"
                                disabled={!user?.is_superuser || user?.user_name !== "superadmin"}
                              />
                            </div>
                            <Form.Text className="text-muted">
                              Data la care a fost instalată aplicația (începutul
                              perioadei de probă).
                            </Form.Text>
                          </Form.Group>
                        </Col>

                        {user?.user_name === "superadmin" && (
                          <Col md={6}>
                            <Form.Group className="mt-4">
                              <Form.Check
                                type="checkbox"
                                id="ok_go"
                                name="ok_go"
                                label="Validare continuare (OK_GO)"
                                checked={!!form.ok_go}
                                onChange={handleChange}
                                className="fw-semibold text-dark"
                                disabled={user?.user_name !== "superadmin"}
                              />
                              <Form.Text className="text-muted">
                                Permite funcționarea nelimitată după perioada de
                                probă de 30 de zile.
                              </Form.Text>
                            </Form.Group>
                          </Col>
                        )}

                        <Col md={12} className="mt-3">
                          <Row className="align-items-center">
                            <Col xs="auto">
                              <Form.Label className="fw-semibold mb-0">
                                Versiune Bază Date:
                              </Form.Label>
                            </Col>
                            <Col xs="auto">
                              <Form.Control
                                type="text"
                                name="versiune_baza"
                                readOnly
                                value={form.versiune_baza ?? ""}
                                onChange={handleChange}
                                size="sm"
                                style={{ width: "90px" }}
                              />
                            </Col>
                          </Row>
                        </Col>
                      </Row>

                      {user?.is_superuser && user?.user_name === "superadmin" && (
                        <>
                          <h6 className="fw-bold mt-4 mb-3">
                            Variantă Aplicație (Superadmin)
                          </h6>
                          <Row className="g-3">
                            <Col md={12} className="mb-2">
                              <Form.Group>
                                <Form.Label className="fw-semibold d-block">
                                  Variantă Aplicație
                                </Form.Label>
                                <div className="d-flex flex-wrap gap-4 align-items-center py-2 border rounded px-3 bg-white">
                                  {[
                                    "LITE",
                                    "STANDARD",
                                    "SANTIER",
                                    "SERVICE_AUTO",
                                    "CONTOR",
                                  ].map((variant) => (
                                    <Form.Check
                                      inline
                                      type="radio"
                                      id={`app-variant-${variant}`}
                                      key={variant}
                                      label={variant}
                                      name="app_variant"
                                      checked={form.app_variant === variant}
                                      onChange={() =>
                                        handleAppVariantChange(variant)
                                      }
                                      className="fw-semibold mb-0"
                                    />
                                  ))}
                                </div>
                                <Form.Text className="text-muted">
                                  Selectarea variantei controlează automat
                                  versiunea nomenclatorului de produse
                                  (ver_parts) și a comenzilor (ver_cda).
                                </Form.Text>
                              </Form.Group>
                            </Col>
                          </Row>

                          <h6 className="fw-bold mt-4 mb-3">Setări Producție</h6>
                          <Row className="g-3">
                            <Col md={6}>
                              <Form.Group>
                                <Form.Label className="fw-medium">ID Gestiune Materii Prime (Sursă)</Form.Label>
                                <Form.Select
                                  name="productie_gestiune_sursa_id"
                                  value={form.productie_gestiune_sursa_id || ""}
                                  onChange={handleChange}
                                >
                                  <option value="">-- Alege --</option>
                                  {gestiuni.map(g => (
                                    <option key={g.id} value={g.id}>{g.bxnume}</option>
                                  ))}
                                </Form.Select>
                              </Form.Group>
                            </Col>
                            <Col md={6}>
                              <Form.Group>
                                <Form.Label className="fw-medium">ID Gestiune Producție (Destinație)</Form.Label>
                                <Form.Select
                                  name="productie_gestiune_dest_id"
                                  value={form.productie_gestiune_dest_id || ""}
                                  onChange={handleChange}
                                >
                                  <option value="">-- Alege --</option>
                                  {gestiuni.map(g => (
                                    <option key={g.id} value={g.id}>{g.bxnume}</option>
                                  ))}
                                </Form.Select>
                              </Form.Group>
                            </Col>
                          </Row>
                        </>
                      )}

                      <h6 className="fw-bold mt-4 mb-3">
                        Tarife Manoperă (Service Auto)
                      </h6>
                      <Row className="g-3 mb-4">
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label className="fw-semibold">
                              Skill 1 — Ușoară (lei/oră, fără TVA)
                            </Form.Label>
                            <Form.Control
                              type="number"
                              step="any"
                              name="tarif_skill1"
                              value={form.tarif_skill1 ?? 0.0}
                              onChange={handleChange}
                              placeholder="ex: 100.00"
                            />
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label className="fw-semibold">
                              Skill 2 — Complicată (lei/oră, fără TVA)
                            </Form.Label>
                            <Form.Control
                              type="number"
                              step="any"
                              name="tarif_skill2"
                              value={form.tarif_skill2 ?? 0.0}
                              onChange={handleChange}
                              placeholder="ex: 150.00"
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                      <hr className="my-4" />
                      <h6 className="text-uppercase fw-bold text-muted mb-3">Setup devize</h6>
                      <Form.Check id="setup-deviz-print-part-codes" className="mb-3" label="Tipărește codul pieselor" checked={form.service_print_part_codes !== false} onChange={e=>setForm(f=>({...f,service_print_part_codes:e.target.checked}))}/>
                      <div className="text-muted small mb-3">Se aplică la tipărirea facturilor din deviz.</div>
                      <h6 className="text-uppercase fw-bold text-muted mb-3">Gestiuni Automate Service Auto</h6>
                      <Row className="g-3 mb-4">
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label className="fw-medium">ID Gestiune Depozit (Sursă)</Form.Label>
                            <Form.Select
                              name="service_gestiune_sursa_id"
                              value={form.service_gestiune_sursa_id || ""}
                              onChange={handleChange}
                            >
                              <option value="">-- Alege --</option>
                              {gestiuni.map(g => (
                                <option key={g.id} value={g.id}>{g.bxnume}</option>
                              ))}
                            </Form.Select>
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label className="fw-medium">ID Gestiune Service (Destinație)</Form.Label>
                            <Form.Select
                              name="service_gestiune_dest_id"
                              value={form.service_gestiune_dest_id || ""}
                              onChange={handleChange}
                            >
                              <option value="">-- Alege --</option>
                              {gestiuni.map(g => (
                                <option key={g.id} value={g.id}>{g.bxnume}</option>
                              ))}
                            </Form.Select>
                          </Form.Group>
                        </Col>
                      </Row>
                    </Card>
                  </Col>
                </Row>
              </Tab>
              
              <Tab eventKey="securitate" title="6. Securitate">
                <Row className="g-3 mt-2">
                  <Col md={12}>
                    <Card className="bg-light border-0 p-3 mb-3">
                      <h6 className="fw-bold mb-3">Autentificare și Acces</h6>
                      <Row className="g-3">
                        <Col md={6}>
                          <Form.Group>
                            <Form.Check
                              type="checkbox"
                              id="is_2fa_enabled"
                              name="is_2fa_enabled"
                              label="Activare autentificare în doi pași (2FA la Login)"
                              checked={!!form.is_2fa_enabled}
                              onChange={handleChange}
                              className="fw-semibold text-dark"
                            />
                            <Form.Text className="text-muted">
                              Trimite un cod de verificare unic pe e-mailul utilizatorului la fiecare conectare.
                            </Form.Text>
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label className="fw-semibold">
                              Lista IP-uri permise (separate prin virgulă)
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="ip_uri_permise"
                              value={form.ip_uri_permise || ""}
                              onChange={handleChange}
                              placeholder="ex: 192.168.1.1, 10.0.0.1"
                            />
                            <Form.Text className="text-muted">
                              Logarea va fi permisă doar de pe aceste adrese. Lăsați gol pentru a permite din orice locație.
                            </Form.Text>
                          </Form.Group>
                        </Col>
                      </Row>
                    </Card>
                  </Col>

                  <Col md={12}>
                    <Card className="bg-light border-0 p-3 mb-3">
                      <h6 className="fw-bold mb-3">Politici de Parolă și Cont</h6>
                      <Row className="g-3">
                        <Col md={4}>
                          <Form.Group>
                            <Form.Label className="fw-semibold">Max. încercări eșuate (Lockout)</Form.Label>
                            <Form.Control
                              type="number"
                              name="sec_max_failed_logins"
                              value={form.sec_max_failed_logins ?? 5}
                              onChange={handleChange}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={4}>
                          <Form.Group>
                            <Form.Label className="fw-semibold">Timp blocare (minute)</Form.Label>
                            <Form.Control
                              type="number"
                              name="sec_lockout_minutes"
                              value={form.sec_lockout_minutes ?? 15}
                              onChange={handleChange}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={4}>
                          <Form.Group>
                            <Form.Check
                              type="checkbox"
                              id="sec_complex_password"
                              name="sec_complex_password"
                              label="Parolă complexă obligatorie"
                              checked={!!form.sec_complex_password}
                              onChange={handleChange}
                              className="fw-semibold text-dark mt-4"
                            />
                          </Form.Group>
                        </Col>
                        <Col md={4}>
                          <Form.Group>
                            <Form.Label className="fw-semibold">Expirare parolă (zile)</Form.Label>
                            <Form.Control
                              type="number"
                              name="sec_password_expiration_days"
                              value={form.sec_password_expiration_days ?? 0}
                              onChange={handleChange}
                            />
                            <Form.Text className="text-muted">0 = dezactivat</Form.Text>
                          </Form.Group>
                        </Col>
                        <Col md={4}>
                          <Form.Group>
                            <Form.Label className="fw-semibold">Expirare sesiune inactivitate (minute)</Form.Label>
                            <Form.Control
                              type="number"
                              name="sec_session_timeout_minutes"
                              value={form.sec_session_timeout_minutes ?? 0}
                              onChange={handleChange}
                            />
                            <Form.Text className="text-muted">0 = dezactivat</Form.Text>
                          </Form.Group>
                        </Col>
                        <Col md={4}>
                          <Form.Group>
                            <Form.Check
                              type="checkbox"
                              id="allow_concurrent_logins"
                              name="allow_concurrent_logins"
                              label="Permite conectări multiple simultane"
                              checked={form.allow_concurrent_logins !== false}
                              onChange={handleChange}
                              className="fw-semibold text-dark mt-4"
                            />
                          </Form.Group>
                        </Col>
                        <Col md={4}>
                          <Form.Group>
                            <Form.Label className="fw-semibold">Max. luni deschise</Form.Label>
                            <Form.Control
                              type="number"
                              name="sec_max_luni_deschise"
                              value={form.sec_max_luni_deschise ?? 3}
                              onChange={handleChange}
                              min={1}
                              max={5}
                            />
                            <Form.Text className="text-muted">Maximum 5 luni</Form.Text>
                          </Form.Group>
                        </Col>
                      </Row>
                    </Card>
                  </Col>
                </Row>
              </Tab>
              
              <Tab eventKey="serii" title="7. Serii Documente">
                <div className="mt-3">
                  <SeriiConfig />
                </div>
              </Tab>
              <Tab eventKey="magazin" title="8. Magazin online"><MagazinOnline /></Tab>
            </Tabs>

            <HelpModal
              show={showHelp}
              onHide={() => setShowHelp(false)}
              title="Manual de Utilizare ERP"
            >
              <TreeHelp defaultChapter="configurare" />
            </HelpModal>

            <AccountPickerModal
              show={showTaxaVamaPicker}
              onHide={() => setShowTaxaVamaPicker(false)}
              onSelect={(acc) => {
                setOptTaxaVama(acc);
                setForm((f) => ({ ...f, cont_taxa_vama_id: acc.id }));
              }}
            />

            <AccountPickerModal
              show={showTvaVamaPicker}
              onHide={() => setShowTvaVamaPicker(false)}
              onSelect={(acc) => {
                setOptTvaVama(acc);
                setForm((f) => ({ ...f, cont_tva_vama_id: acc.id }));
              }}
            />

            <AccountPickerModal
              show={showComisionVamaPicker}
              onHide={() => setShowComisionVamaPicker(false)}
              onSelect={(acc) => {
                setOptComisionVama(acc);
                setForm((f) => ({ ...f, cont_comision_vama_id: acc.id }));
              }}
            />

            <hr />

            <div className="d-flex justify-content-between align-items-center mt-4">
              <Button variant="secondary" onClick={() => navigate("/firma/1")}>
                Renunță
              </Button>
              <Button
                variant="primary"
                type="submit"
                size="lg"
                disabled={submitting}
              >
                {submitting ? "Se salvează..." : "Salvează modificările"}
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
}
